module.exports = __webpack_public_path__ + "img/5.75630d64.jpg";